import React from "react";
import { checkRegDate, times } from "../../../utils/date";
import {
  StyledA,
  StyledButton,
  StyledImg,
  StyledLi,
  StyledP,
  StyledSpan,
  StyledSpanAddress,
} from "./styles";
export var ActivityItem = function ActivityItem(_ref) {
  var event = _ref.event,
    onClickEvent = _ref.onClickEvent;
  return /*#__PURE__*/ React.createElement(
    StyledLi,
    null,
    /*#__PURE__*/ React.createElement(StyledImg, {
      src: event.event_type.logo,
      alt: event.event_type.title,
    }),
    /*#__PURE__*/ React.createElement(StyledSpan, null, times.getDayOfWeek(event.start_time)),
    /*#__PURE__*/ React.createElement(StyledSpanAddress, null, event.address),
    /*#__PURE__*/ React.createElement(StyledP, null, event.event.title_above),
    event.external_url
      ? checkRegDate(event.registration_close)
        ? /*#__PURE__*/ React.createElement(
            StyledA,
            {
              target: "_blank",
              rel: "noreferrer",
              href: event.external_url,
            },
            "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0437\u0430\u043A\u0440\u044B\u0442\u0430"
          )
        : /*#__PURE__*/ React.createElement(
            StyledA,
            {
              target: "_blank",
              rel: "noreferrer",
              href: event.external_url,
            },
            "\u041F\u0440\u0438\u043D\u044F\u0442\u044C \u0443\u0447\u0430\u0441\u0442\u0438\u0435"
          )
      : checkRegDate(event.registration_close)
      ? /*#__PURE__*/ React.createElement(
          StyledButton,
          {
            disabled: checkRegDate(event.registration_close),
            onClick: function onClick() {},
          },
          "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0437\u0430\u043A\u0440\u044B\u0442\u0430"
        )
      : /*#__PURE__*/ React.createElement(
          StyledButton,
          {
            disabled: checkRegDate(event.registration_close),
            onClick: function onClick() {
              onClickEvent(event, event.city.id);
            },
          },
          "\u041F\u0440\u0438\u043D\u044F\u0442\u044C \u0443\u0447\u0430\u0441\u0442\u0438\u0435"
        )
  );
};
